var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_105_1",
    "data-name": "Component 105 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2144",
    "data-name": "Ellipse 2144",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#b92ddb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(14.999 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66831",
    "data-name": "Group 66831",
    transform: "translate(0.001 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66830",
    "data-name": "Group 66830",
    transform: "translate(0 3.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79223",
    "data-name": "Path 79223",
    d: "M6.907,20.9a4.147,4.147,0,0,1-3.914-2.89l-.039-.13a4.227,4.227,0,0,1-.191-1.228V8.932L.082,18.1a2.58,2.58,0,0,0,1.759,3.121l17.088,4.691a2.465,2.465,0,0,0,3.025-1.768l1-3.245Z",
    transform: "translate(-0.001 -8.932)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79224",
    "data-name": "Path 79224",
    d: "M9,9A2,2,0,1,0,7,7,2,2,0,0,0,9,9Z",
    transform: "translate(0.91 -5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79225",
    "data-name": "Path 79225",
    d: "M21.5,2H6.5A2.5,2.5,0,0,0,4,4.5v11A2.5,2.5,0,0,0,6.5,18h15A2.5,2.5,0,0,0,24,15.5V4.5A2.5,2.5,0,0,0,21.5,2ZM6.5,4h15a.5.5,0,0,1,.5.5v7.1L18.841,7.913A1.791,1.791,0,0,0,17.5,7.3a1.749,1.749,0,0,0-1.336.631L12.45,12.387,11.24,11.18a1.755,1.755,0,0,0-2.48,0L6,13.939V4.5A.5.5,0,0,1,6.5,4Z",
    transform: "translate(2.182)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageInput);
export default __webpack_public_path__ + "static/media/image_input.991fd371515f6cef24a0683998af1e89.svg";
export { ForwardRef as ReactComponent };